import { Grid } from '@material-ui/core'
import ITalentsData from 'data/abitilies/interfaces/ITalentsData'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import Tabs from './tabs'

import { _route } from 'routes/config'

import { Circle, Header, HeaderDetail, PlusOnlyPopup } from 'components'
import { get } from 'lodash'
import { isEducator } from 'services/user'
import { childDashboardNameTransform } from 'services/utils'

export interface INativeProps {
  talentsChartData: ITalentsData[]
  patientDetail: any
  user?: any
  loading: boolean
  isOpenPlusOnlyPopup: boolean
  openPlusOnlyPopup: () => void
  closePlusOnlyPopup: () => void
  toggleHistoryModal: () => void
  activeDate?: number | string
  openShareModal: () => void
}

export interface IState {}

export interface IProps extends INativeProps, RouteComponentProps {}

class Content extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props)
  }

  onEdit = () => {
    const {
      history,
      match: { params }
    } = this.props
    history.push(`/patients_list/${(params as any).id}/edit`)
  }

  setActivePlusOnly = (status: boolean): void => {
    const { openPlusOnlyPopup, closePlusOnlyPopup } = this.props
    if (status) {
      openPlusOnlyPopup()
    } else {
      closePlusOnlyPopup()
    }
  }

  renderInfo = () => {
    const {
      user,
      talentsChartData,
      patientDetail,
      loading,
      isOpenPlusOnlyPopup,
      openPlusOnlyPopup,
      history,
      history: {
        location: { state }
      },
      activeDate,
      toggleHistoryModal,
      openShareModal
    } = this.props
    const patientFirstName = patientDetail?.first_name
    const showHeader = !isEducator(user?.role)
    return (
      <React.Fragment>
        <div className="fixed-holder mui-fixed">
          <Header
            type="color"
            oneRow={true}
            defaultRightSide={true}
            title={
              patientFirstName && childDashboardNameTransform(patientFirstName)
            }
            smallHeader={true}
            goBackAction={this.goBackAction}
          />
          {!loading && showHeader && (
            <HeaderDetail
              openPlusOnlyPopup={openPlusOnlyPopup}
              isEvaluationCompletedOpen={
                state && get(state, 'isEvaluationCompletedOpen', false)
              }
            />
          )}
        </div>
        <PlusOnlyPopup
          setActive={this.setActivePlusOnly}
          open={isOpenPlusOnlyPopup}
          history={history}
        />
        {loading && (
          <div
            style={{
              width: '100%',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
            className="content"
          >
            <Circle />
          </div>
        )}
        {!loading && (
          <Tabs
            toggleHistoryModal={toggleHistoryModal}
            activeDate={activeDate}
            user={user}
            patientDetail={patientDetail}
            talentsChartData={talentsChartData}
            openPlusOnlyPopup={openPlusOnlyPopup}
            openShareModal={openShareModal}
          />
        )}
      </React.Fragment>
    )
  }

  goBackAction = () => {
    this.props.history.push(_route.child.list)
  }

  render() {
    return (
      <Grid
        container={true}
        direction="column"
        alignItems="center"
        className="patient-details-page page-min-content with-fixed"
      >
        {this.renderInfo()}
      </Grid>
    )
  }
}
const WithRouter = withRouter(Content)

export default (props: INativeProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/pages/PatientDetails/content.tsx